"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSmPriceAdjustRecord = deleteSmPriceAdjustRecord;
exports.getSamCategoryList = getSamCategoryList;
exports.getSmPriceAdjustRecords = getSmPriceAdjustRecords;
exports.smCategoryPriceAdjust = smCategoryPriceAdjust;
exports.syncSamCategoryAll = syncSamCategoryAll;
exports.updateSamCategoryStatus = updateSamCategoryStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 商城分类列表（树形）
 * POST sm/mall/category/list
 * body: categoryId, groupLevel, groupName, parentId, status(1-启用,0-禁用)
 */
function getSamCategoryList(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类状态切换
 * POST sm/mall/category/status
 * body: categoryId, status(1-启用,0-禁用)
 */
function updateSamCategoryStatus(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/status',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 商城分类同步全部
 * POST sm/mall/category/syncAll，无参数
 */
function syncSamCategoryAll() {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/syncAll',
    method: 'POST'
  });
}

/**
 * 山姆分类调价
 * POST /admin/sm/mall/category/price-adjust
 * body: categoryId, categoryName, adjustRatio, remark
 */
function smCategoryPriceAdjust(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/price-adjust',
    method: 'POST',
    data: data
  });
}

/**
 * 山姆分类调价记录列表（分页）
 * POST /admin/sm/mall/category/price-adjust/records
 * body: categoryId, page, limit
 */
function getSmPriceAdjustRecords(data) {
  return (0, _request.default)({
    url: '/admin/sm/mall/category/price-adjust/records',
    method: 'POST',
    data: data
  });
}

/**
 * 删除山姆分类调价记录
 * DELETE /admin/sm/mall/category/price-adjust/{id}
 */
function deleteSmPriceAdjustRecord(id) {
  return (0, _request.default)({
    url: "/admin/sm/mall/category/price-adjust/".concat(id),
    method: 'DELETE'
  });
}